import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=5337269a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=5337269a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337269a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5337269a')) {
      api.createRecord('5337269a', component.options)
    } else {
      api.reload('5337269a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=5337269a&scoped=true&", function () {
      api.rerender('5337269a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z2wjo4nUn78K/JS/comp/DocBox.vue"
export default component.exports